/**
 * Espelha api-perfil-investimento/Domain/Enums/TipoCampanha.cs — hoje só existe
 * o valor Suitability no back-end (COD_CAMPANHA da PRE_TBL_CAMPANHA_SUITABILITY).
 */
export enum TipoCampanhaBack {
  Suitability = 5,
}

/**
 * Rótulo curto de exibição (decisão do PO, 2026-08-10): o catálogo devolve
 * "Perfil de Investimento - Suitability", mas a tela deve mostrar o mesmo texto usado em
 * "Selecione o tipo de Campanha" no formulário de criar/editar — só "Suitability".
 */
export const TIPO_CAMPANHA_LABEL: Record<TipoCampanhaBack, string> = {
  [TipoCampanhaBack.Suitability]: 'Suitability',
};
